<template>
  <div class="container-fluid" v-if="orderInvoiceData !== null">
    <label class="pill-danger pulse-danger cursor-pointer float-right" @click="showDetailHandler"
           v-if="orderInvoiceData.total > 0">
      {{ orderInvoiceData.total }} facturas con error
    </label>

    <div class="clearfix"></div>

    <vs-popup :active.sync="showDialog" title="Facturas con error" :fullscreen="true">
      <div class="row">
        <div class="col-md-8">
          <vx-card :title="`Listado de facturas (${date})`">
            <div class="row mb-2">
              <div class="col-md-4">
                <vs-input
                  placeholder="RFC"
                  v-model="rfcSearch"
                  @keyup.enter="getInvoiceOrderAlert"
                ></vs-input>
              </div>
              <div class="col-md-4">{{ `Mostrando de ${orderInvoiceData.from} a ${orderInvoiceData.to}` }}</div>
              <div class="col-md-4 flex">
                <div class="text-right">
                  <!--<vs-button size="small" @click="resendAllConfirm">
                    Reenviar todo
                  </vs-button>-->

                  <!--<vs-button color="dark" size="small" class="ml-2" @click="resetAllConfirm">
                    Reiniciar todo
                  </vs-button>-->
                </div>
              </div>
            </div>

            <vs-table :data="orderInvoiceData.data" stripe>
              <template slot="thead">
                <vs-th>RFC</vs-th>
                <vs-th>Tipo</vs-th>
                <vs-th>Error</vs-th>
                <vs-th style="width: 15%">Opciones</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr v-for="item in data" :key="item.id">
                  <vs-td>{{ item.rfc }}</vs-td>
                  <vs-td>{{ item.type }}</vs-td>
                  <vs-td>{{ item.error_message }}</vs-td>
                  <vs-td>
                    <vs-button
                      class="float-right"
                      @click="sendOrderInvoiceHandler(item)"
                      icon="send"></vs-button>
                    <vs-button
                      @click="showOrderInvoiceDetailHandler(item)"
                      color="light" class="text-dark float-right" icon="edit"></vs-button>

                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-row class="mt-2">
              <vs-col>
                <vs-pagination
                  :total="orderInvoiceData.last_page"
                  v-model="orderInvoiceData.current_page"
                  :per-page="orderInvoiceData.per_page"
                  @change="changePageHandler"/>
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
        <div class="col-md-4">
          <vx-card title="Métricas">
            <statistics-card-line
              hideChart
              icon-right
              class="m-2"
              icon="BookmarkIcon"
              :statistic="orderInvoiceData.metrics.by_rfc"
              text-color="success"
              color="success"
              statisticTitle="RFC's unicos"></statistics-card-line>

            <statistics-card-line
              hideChart
              icon-right
              class="m-2"
              icon="FileIcon"
              :statistic="orderInvoiceData.metrics.by_invoice_j"
              text-color="success"
              color="success"
              statisticTitle="Facturas de retención (J)"></statistics-card-line>

            <statistics-card-line
              hideChart
              icon-right
              class="m-2"
              icon="FileIcon"
              :statistic="orderInvoiceData.metrics.by_invoice_t"
              text-color="success"
              color="success"
              statisticTitle="Facturas de terceros (T)"></statistics-card-line>

            <statistics-card-line
              hideChart
              icon-right
              class="m-2"
              icon="FileIcon"
              :statistic="orderInvoiceData.metrics.by_invoice_f"
              text-color="success"
              color="success"
              statisticTitle="Facturas de RG (F)"></statistics-card-line>
          </vx-card>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      :active.sync="showOrderInvoiceDetailDialog"
      title="Detalle de factura"
      style="z-index: 1000000"
      fullscreen
    >
      <div v-if="orderInvoiceDetailData !== null">
        <div class="row">
          <div class="col-md-8">
            <vs-textarea
              class="w-full mt-5"
              rows="30"
              v-model="orderInvoiceJsonEditor"></vs-textarea>
          </div>
          <div class="col-md-4">
            <vs-list>
              <vs-list-item title="Id" :subtitle="orderInvoiceSelected.id"/>
              <vs-list-item title="RFC" :subtitle="orderInvoiceSelected.rfc"/>
              <vs-list-item title="Tipo factura" :subtitle="orderInvoiceSelected.type"/>
              <vs-list-item title="Error" :subtitle="orderInvoiceSelected.error_message"/>
            </vs-list>

            <div class="mt-5">
              <vs-button size="small" @click="saveAndResendHandler(orderInvoiceSelected)">
                Guardar y reenviar
              </vs-button>
              <vs-button size="small" color="light" class="text-dark ml-2" @click="saveHandler">
                Solo guardar
              </vs-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        No se encontró la factura
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "OrderInvoiceAlert",
  data: () => ({
    orderInvoiceData: null,
    showDialog: false,
    showOrderInvoiceDetailDialog: false,
    rfcSearch: null,
    currentPage: 1,
    orderInvoiceDetailData: null,
    orderInvoiceJsonEditor: null,
    orderInvoiceSelected: null
  }),
  props: {
    date: {
      type: String,
    },
  },
  mounted() {
    this.getInvoiceOrderAlert();
  },
  methods: {
    async getInvoiceOrderAlert() {
      this.$vs.loading();

      try {
        let q = "";
        if (this.rfcSearch !== null) {
          q = `&q=${this.rfcSearch}`;
        }

        const {data} = await axios.get(
          `/api/billing/order-invoices?status=error&exercise-date=${this.date}&page=${this.currentPage}${q}`
        );
        this.orderInvoiceData = data;
      } catch (err) {
        swal("Ups!", AxiosErrorException(err), "error");
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    showDetailHandler() {
      this.showDialog = true;
    },
    async showOrderInvoiceDetailHandler(item) {
      this.orderInvoiceSelected = item;
      this.orderInvoiceDetailData = await axios.get(`/api/billing/order-invoices/${item.id}`);
      this.orderInvoiceJsonEditor = JSON.stringify(
        JSON.parse(this.orderInvoiceDetailData.data.payload),
        null,
        4
      );
      this.showOrderInvoiceDetailDialog = true;
    },
    async changePageHandler(page) {
      this.currentPage = page;
      await this.getInvoiceOrderAlert();
    },
    async resendAllConfirm() {
      const confirm = await swal({
        title: `¿Reenvíar las facturas?`,
        text: "Esta acción reprocesará las facturas como están en la orden de facturación",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })

      if (confirm) {
        await axios.post(`/api/billing/order-invoices/resend/all`, {
          exercise_date: this.date
        });
      }
    },
    async resetAllConfirm() {
      const confirm = await swal({
        title: `¿Resetear las facturas?`,
        text: "Esta acción regenerará las ordenes de facturas desde su origen y reprocesará las facturas",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })

      if (confirm) {
        await axios.post(`/api/billing/order-invoices/reset/all`, {
          exercise_date: this.date
        });
      }
    },
    async sendOrderInvoiceHandler(item) {
      try {
        await axios.post(`/api/billing/order-invoices/${item.id}/resend`, {});
        this.successNotif("Factura enviada", "La factura se ha enviado correctamente")
      } catch (e) {
        this.errorNotif("Error", "Error al enviar la factura");
      }
    },
    async saveAndResendHandler() {
      await this.saveHandler();
      await this.resendHandler();
    },
    async resendHandler() {
      this.$vs.loading();
      try {
        await axios.post(`/api/billing/order-invoices/${this.orderInvoiceSelected.id}/resend`, {});
        this.successNotif("Factura enviada", "La factura se ha enviado correctamente")
      } catch (e) {
        this.errorNotif("Error", "Error al enviar la factura");
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    async saveHandler() {
      this.$vs.loading();
      try {
        await axios.post(`/api/billing/order-invoices/${this.orderInvoiceSelected.id}/save`, {
          payload: this.orderInvoiceJsonEditor
        });
        this.successNotif("Factura guardada", "La factura se ha guardado correctamente")
      } catch (e) {
        this.errorNotif("Error", "Error al guardar la factura");
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
  }
}
</script>

<style>
.swal-overlay {
  z-index: 1000000;
}
</style>